<!-- Start -->
<section class="relative -mt-[50px] md:pb-24 pb-16">
  <div class="container-fluid ">
    <div class="container z-1">
      <div class="d-flex" id="reserve-form">
          <div class="md:w-5/6 mx-auto">
              <div class="lg:col-span-10">
                  <div class="bg-white dark:bg-slate-900 border-0 shadow rounded-md p-3">
                      <form action="#">
                          <div class="registration-form text-dark text-start">
                              <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-0 gap-6">

                                  <div class="filter-search-form relative filter-border">
                                      <i class="uil uil-map-marker icons text-earth-dark"></i>
                                      <select [(ngModel)]="filterargs.praktijk" class="form-select" data-trigger name="choices-location" id="choices-location" aria-label="Location select">
                                        <option value="alle" selected="true">Alle praktijken</option>
                                      </select>
                                  </div>

                                  <div class="filter-search-form relative filter-border">
                                      <i class="uil uil-briefcase-alt icons text-earth-dark"></i>
                                      <select [(ngModel)]="filterargs.discipline" class="form-select" data-trigger name="choices-disc" id="choices-disc" aria-label="Discipline select">
                                          <option value="alle" selected="true">Alle disciplines</option>
                                      </select>
                                  </div>

                                  <input (click)="resetFilters()" type="button" id="clear" name="search" style="height: 60px;" class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 searchbtn submit-btn w-100" value="Verwijder filter">
                              </div><!--end grid-->
                          </div><!--end container-->
                      </form>
                  </div>
              </div><!--ed col-->
          </div>
      </div><!--end grid-->
  </div><!--end container-->

  <div class="container mt-8">
      <div class="grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px]">
          <app-member-card *ngFor="let member of (members | teamfilter:filterargs)" [member]="member"></app-member-card>
      </div>
  </div>

  <div class="container mt-8">
    <div class="grid grid-cols-1">
      <div class="relative overflow-hidden lg:px-8 px-6 py-10 rounded-xl shadow-lg dark:shadow-gray-700" *ngIf="selectedDiscipline" [innerHTML]="selectedDiscipline.omschrijving | mdtohtml">
      </div>
    </div>
  </div>

  <div class="container mt-16">
    <div class="grid grid-cols-1">
        <div class="relative overflow-hidden lg:px-8 px-6 py-10 rounded-xl shadow-lg dark:shadow-gray-700">
            <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                <div class="lg:col-span-8 md:col-span-7">
                    <div class="ltr:md:text-left rtl:md:text-right text-center relative z-1">
                        <h3 class="text-2xl font-semibold text-black dark:text-white mb-4">Join our team!</h3>
                        <p class="text-slate-400 max-w-xl">Heb jij de juiste competenties en wil je ons team versterken? Neem contact op met <a class='underline text-earth-xdark' href='/contact'>één van onze vestigingen</a>!</p>
                    </div>
                </div>

                <div class="lg:col-span-4 md:col-span-5">
                  <div class="ltr:text-right rtl:text-left relative z-1">
                      <a [routerLink]="['/vacatures']" class="btn bg-earth-dark/80 hover:bg-earth-dark border-earth-common text-black/70 rounded-md">Ik kom er bij!</a>
                      <a [routerLink]="['/vacatures']" class="btn bg-earth-try hover:bg-earth-dark border-earth-common hover:border-black/70 text-black/70 hover:text-black/70 rounded-md ltr:ml-2 rtl:mr-2">Bekijk vacatures</a>
                  </div>
              </div>
            </div>

            <div class="absolute -top-5 ltr:-left-5 rtl:-right-5">
                <div class="uil uil-envelope lg:text-[150px] text-7xl text-black/5 dark:text-white/5 ltr:-rotate-45 rtl:rotate-45"></div>
            </div>

            <div class="absolute -bottom-5 ltr:-right-5 rtl:-left-5">
                <div class="uil uil-pen lg:text-[150px] text-7xl text-black/5 dark:text-white/5 rtl:-rotate-90"></div>
            </div>
        </div>
    </div>
  </div>
</div><!--end container-->


</section><!--end section-->
<!-- End -->
